export default __webpack_public_path__ + "static/media/mockup.bea5ce38.png";